import { Paper, Grid } from "@material-ui/core";
import {
  InputTextMaster,
  InputOptionMaster,
  InputReactDatepicker,
} from "App/Component/ui";
import {
  STYLE_DEFAULT_MASTER,
  TYPE_INSTANCE4,
  WMS_PBF_INPUT_ADJUSMENT_STOCK,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import { changeHandlerLocalStorageForm, isNull } from "App/utils/helpers";
import React from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

function FormInputAdjusmentStock({ formData, setFormData }) {
  const classes = STYLE_DEFAULT_MASTER();

  const handleChange = (text) => (e) => {
    changeHandlerLocalStorageForm(
      text,
      e,
      formData,
      setFormData,
      WMS_PBF_INPUT_ADJUSMENT_STOCK
    );
  };

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    });

    localStorage.setItem(
      WMS_PBF_INPUT_ADJUSMENT_STOCK,
      JSON.stringify({
        ...formData,
        [name_id]: e?.value,
        [name_label]: e?.label,
      })
    );
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data"
  );

  return (
    <Paper
      classes={classes.root}
      style={{
        padding: "1rem",
      }}>
      <Grid container spacing={1}>
        <Grid item sm={4}>
          <InputTextMaster
            name='id'
            label='ID'
            readOnly
            disabled
            id='id'
            value={formData.id}
            onChange={handleChange("id")}
            placeholder='ID'
          />
        </Grid>
        <Grid item sm={4}>
          {/* <InputTextMaster
            name='date'
            label='TANGGAL'
            id='date'
            readOnly={isNull(formData.id) ? false : true}
            disabled={isNull(formData.id) ? false : true}
            type='datetime-local'
            value={formData.date}
            onChange={handleChange("date")}
            placeholder='date'
          /> */}
          <InputReactDatepicker
            selected={formData.date}
            label='TANGGAL'
            dateFormat='dd/MM/yyyy HH:mm'
            timeFormat='HH:mm'
            showTimeSelect={true}
            timeIntervals={5}
            readOnly={isNull(formData.id) ? false : true}
            disabled={isNull(formData.id) ? false : true}
            handleChangeToday={(e) =>
              setFormData({
                ...formData,
                date: e,
              })
            }
            onChange={(e) =>
              setFormData({
                ...formData,
                date: e,
              })
            }
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name='gudang_id'
            label='GUDANG UTAMA MEDIS'
            id='gudang_id'
            readOnly={isNull(formData.id) ? false : true}
            disabled={isNull(formData.id) ? false : true}
            withSearch={true}
            data={gudangUtama}
            value={formData.gudang_id}
            labelValue={formData.gudang}
            onChange={(e) =>
              changeSelectWithLocalStorage(e, "gudang_id", "gudang")
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default FormInputAdjusmentStock;
